<template>
  <div class="oauth-wrapper">
    <img
      src="@/assets/images/doodles/oauth-success.jpg"
      class="asset"
      alt="Installation successfull"
    />
    <h3>{{ title }}</h3>
    <p>{{ message }}</p>

    <img src="@/assets/images/logo.png" class="logo" alt="Macha Logo" />
  </div>
</template>
  
<script>
export default {
  name: "OauthSuccess",
  data() {
    return {
      title: "Installation Successfull",
      message: "Your Zendesk has successfully installed the Macha AI app",
    };
  },
  components: {},
  methods: {},
};
</script>
  
<style scoped lang="scss">
.oauth-wrapper {
  text-align: center;
  margin-top: 3rem;
}

.asset {
  width: 10rem;
  display: block;
  margin: 1rem auto 2rem;
}

.logo {
  position: absolute;
  display: block;
  width: 5rem;
  margin: auto;
  bottom: 3rem;
  left: 0;
  right: 0;
}
</style>